import { render, staticRenderFns } from "./button-fixed-bottom.vue?vue&type=template&id=13fd2108"
import script from "./button-fixed-bottom.vue?vue&type=script&lang=js"
export * from "./button-fixed-bottom.vue?vue&type=script&lang=js"
import style0 from "./button-fixed-bottom.vue?vue&type=style&index=0&id=13fd2108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports